// extracted by mini-css-extract-plugin
export default {"relate_title":"index_relate_title_f64of"};